import { INavStyles, ITheme } from '@fluentui/react';
import { Theme } from '../../Models/Constants/Enums';

export const getNavStyles = (
    _themeSetting: Theme,
    theme: ITheme
): Partial<INavStyles> => {
    const iconColor = theme.palette.themePrimary;

    return {
        root: {
            selectors: {
                '.ms-Button::after': {
                    width: 4,
                    height: 'calc(100% - 16px)',
                    borderRadius: 4,
                    top: 8,
                    left: 2,
                    background: iconColor,
                    borderLeft: 'unset'
                },
                button: {
                    background: 'var(--cb-app-color-left-nav)',
                },
                'li:last-of-type': {
                    borderTop: `1px solid ${theme.palette.neutralLighter}`
                },
                i: {
                    margin: '0 12px',
                    color: 'var(--cb-app-color-text-primary)'
                }
            }
        },
        link: {
            color: 'var(--cb-app-color-text-primary)'
        }
    };
};
